module.exports = __webpack_public_path__ + "static/media/four-reward.9201bee1.svg";